<template>
  <div class="main">
    <div class="wrap-particles">
      <div v-if="player" class="main-content">
        <b-navbar style="background-color: #fff;">
          <b-navbar-brand class="d-flex justify-content-center align-items-center">
            <img :src="require(`@/assets/team/${player.team}.svg`)" style="height:40px;">
            <h2 class="d-inline p-0 m-0 ml-1 roboto">{{ player.name }}</h2>
          </b-navbar-brand>
        </b-navbar>

        <!-- Waiting State -->
        <div v-if="state == 'waiting'" class="container py-4 text-center text-white h-75">
          <div class="d-flex justify-content-center align-items-center h-100">
            <div>
              <img src="@/assets/astronaut.svg" class="w-50">
              <h3 class="text-white">Waiting for other players.</h3>
            </div>
          </div>
        </div>
        <!-- End Waiting State -->

        <!-- Playing State -->
        <div v-else-if="state == 'playing'" class="h-75 text-white text-center p-4">
          <h2>Shake the phone</h2>
          <div class="d-flex justify-content-center align-items-center h-100">
            <h1 class="display-1 mono">{{ intToString(player.score) }}</h1>
          </div>
        </div>
        <!-- end Playing State -->

        <!-- End State -->
        <div v-if="state == 'end'" class="container py-4 h-75">
          <h1 class="text-white text-center">Leaderboard</h1>
          <div class="mx-auto w-sm-100 w-md-75 w-lg-50 p-2 text-white">
            <div v-for="(team, rank) in leaderBoard" :key="team.key"
              :class="[team[0], 'box', 'border', 'rounded', 'p-1', 'my-4']">
              <b-navbar>
                <b-navbar-brand>
                  <span class="chakra-petch h4 text-white mr-3 text-uppercase">{{ rank+1 }}</span>
                  <img :src="require(`@/assets/team/${team[0]}.svg`)" style="height:40px;">
                  <span class="text-white ml-1 text-uppercase">{{ team[0] }}</span>
                </b-navbar-brand>

                <!-- <span class="ml-auto mono">
                  {{ intToString(team[1]) }}
                </span> -->
              </b-navbar>
            </div>
          </div>
        </div>
        <!-- End End State -->

      </div>

      <vue-particles color="#ffffff" :particleOpacity="0.3" :particlesNumber="80" shapeType="circle" :particleSize="5"
        :lineLinked="false" :moveSpeed="1" :hoverEffect="false" :clickEffect="false" />
    </div>
  </div>
</template>

<script>
import firebase from 'firebase'
let Shake = require('shake.js')

export default {
  name: 'gameControl',
  data() {
    return {
      player: null,
      state: 'waiting',
      mode: 'mining',
      scores: null,
      teams: null
    }
  },
  props: ['pin', 'uid'],
  mounted() {
    let self = this
    firebase.database().ref('games/' + self.pin + '/players/' + self.uid).on('value', function (snapshot) {
      let player = snapshot.val()
      if (player) {
        self.player = player
      } else {
        self.$router.replace('/join')
      }
    })

    firebase.database().ref('games/' + self.pin + '/state').on('value', function (snapshot) {
      self.state = snapshot.val()
    })

    firebase.database().ref('games/' + self.pin + '/mode').on('value', function (snapshot) {
      self.mode = snapshot.val()
    })

    firebase.database().ref('games/' + self.pin + '/scores').on('value', function (snapshot) {
      self.scores = snapshot.val()
    })

    firebase.database().ref('games/' + self.pin + '/teams').on('value', function (snapshot) {
      self.teams = snapshot.val()
    })
  },
  computed: {
    leaderBoard: function () {
      let self = this
      let leaderBoard = []

      if (self.scores && self.teams) {
        for (let team in self.teams) {
          leaderBoard.push([team, self.scores[team]])
        }

        leaderBoard.sort(function (a, b) {
          return a[1] - b[1]
        })

        leaderBoard.reverse()
      }

      return leaderBoard
    }
  },
  watch: {
    state() {
      let self = this
      let myShakeEvent = new Shake()
      if (self.state == 'playing') {
        myShakeEvent.start()

        window.addEventListener('shake', self.shakeEventDidOccur, false)
      } else if (self.state == 'end') {
        window.removeEventListener('shake', self.shakeEventDidOccur, false);
      }
    }
  },
  methods: {
    intToString: function (int) {
      const COUNT_ABBRS = [ '', 'k', 'M', 'G', 'T', 'P', 'E', 'Z', 'Y' ]
      const i = 0 === int ? int : Math.floor(Math.log(int) / Math.log(1000))
      let result = parseFloat((int / Math.pow(1000, i)).toFixed(2))
      return result += `${COUNT_ABBRS[i]}`
    },
    shakeEventDidOccur: function () {
      let self = this
      firebase.database().ref('games/' + self.pin + '/players/' + self.uid).update({
        score: self.player.score + 1
      }).catch(function (err) {
        console.log(err)
      })
    }
  }
}
</script>

<style scoped>
.main {
  width: 100vw;
  min-height: 100vh;
  /* overflow: hidden; */
  background-color: #000;
}

/* HIDE RADIO */
[type=radio] { 
  position: absolute;
  opacity: 0;
}

/* IMAGE STYLES */
[type=radio] + img {
  cursor: pointer;
  opacity: 0.4;
  filter: alpha(opacity=40); /* msie */
}

/* CHECKED STYLES */
[type=radio]:checked + img {
  opacity: 1;
  filter: none;
}

.nirvana, .triangulum {
  border-color: #2196f3 !important;
  background-color: #fff1;
}
.valkyrie, .hydra {
  border-color: #f44336 !important;
  background-color: #fff1;
}
.andromeda {
  border-color: #4caf50 !important;
  background-color: #fff1;
}
.sagittarius {
  border-color: #ffeb3b !important;
  background-color: #fff1;
}
</style>

